  export const sanitizePhone = (dirtyPhone: any, countryCode: string) => {
    const fullyQualifiedPrefix = new RegExp(`^\\+${countryCode}`);
    const countryCodePrefix = new RegExp(`^${countryCode}`);
    let cleanPhone = dirtyPhone.replace(/^(00|011)/,"+").replace(/[^\+\d]/g,"").replace(fullyQualifiedPrefix,"").replace(/^\+/g,"").replace(countryCodePrefix,"").replace(/^0/g,"").replace(/[^\d]/g,"");
    return cleanPhone;
  }